module.exports = __webpack_public_path__ + "media/markers/marker-transparent-light-blue-e4ee8715.svg";